import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom"; //接收参数关键代码
import { Empty, SpinLoading, Toast } from "antd-mobile";
import { getBill } from "api/api";
import {
  BpmContributionTitle,
  BpmContributionDate,
} from "components/BpmContribution";
import { BpmButton } from "components/BpmButton";
import "../../../static/css/contribution.css";

/** 养老医保缴费查询 */
export function Contribution() {
  const location = useLocation();
  const data = location.state; //接收navigate的参数
  const { idNum, name, startDate, endDate } = data || {};
  const [billData, setBillData] = useState();
  const [loading, setLoading] = useState(true); // 是否显示加载圈

  //传给接口的参数
  const tempInfo = {
    idNum: idNum,
    name: name,
    startDate: startDate,
    endDate: endDate,
  };
  /**接口调用 */
  useEffect(() => {
    getBill(tempInfo).then((res) => {
      if (res.success && res.data.status === 1) {
        setBillData(res.data);
        setLoading(false);
      } else {
        Toast.show({
          icon: "fail",
          content: `${res.data.result}`,
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /** 返回上一页 */
  function handleBackClick() {
    window.history.back();
  }

  return (
    <>
      <div className="co-top">
        <div className="co-heard">缴费查询</div>
        {loading ? (
          <div className="co-loading">
            <SpinLoading className="co-spinLoading" />
          </div>
        ) : (
          <>
            <BpmContributionTitle
              title="养老保险缴费情况"
              totalMonth={billData ? billData?.retirementTimes : "0"}
            />
            {
              billData
                ?
                (
                  <BpmContributionDate
                    year={billData?.retirementYear}
                    month={billData?.retirementMonths}
                    name={name}
                    idNum={idNum}
                  />
                )
                :
                (
                  <Empty
                    description="暂无数据"
                    imageStyle={{ width: 128 }}
                  />
                )
            }
            <BpmContributionTitle
              title="医保缴费情况"
              totalMonth={billData ? billData?.medicalTimes : "0"}
            />
            {
              billData
                ?
                (
                  <BpmContributionDate
                    year={billData?.medicaltYear}
                    month={billData?.medicalMonths}
                    name={name}
                    idNum={idNum}
                  />
                )
                :
                (
                  <Empty
                    description="暂无数据"
                    imageStyle={{ width: 128 }}
                  />
                )
            }
          </>
        )}
        {/* 返回上一页*/}
        <BpmButton
          type="button"
          content={'返回'}
          onClick={handleBackClick}
          className='stepBut'
        />
      </div>
    </>
  );
}
